<div class="info-box-wrapper" [ngClass]="className">
  <h2 class="info-box-title">{{ title }}</h2>
  <div class="info-box-text">
    <ng-content />
  </div>
</div>
